// Fronted/src/routes/index.js
import { Route, Routes } from 'react-router-dom';

// Admin Components

// Public Components
// Assume these are imported from their respective locations
import About from '../components/About';
import CellLocator from '../components/CellGroups/CellGroupLocator';
import Contact from '../components/Contact';
import Annoncements from '../components/Contents/Annoncements';
import Campus from '../components/Contents/Campus';
import CellMinistry from '../components/Contents/CellMinistry';
import Giving from '../components/Contents/Giving';
import SoulWinning from '../components/Contents/SoulWinning';
import WelcomePage from '../components/Contents/Welcome';
import Events from '../components/Events/EventsAnnouncements';
import GivingFailure from '../components/Giving/GivingFailed';
import GivingSuccess from '../components/Giving/GivingSuccess';
import Home from '../components/Home';
import ChildrenMinistry from '../components/Ministries/ChildrenMinistry';
import { default as MinistryPage } from '../components/Ministries/MinistryPage';
import TeensMinistry from '../components/Ministries/TeensMinistry';
import WomenMinistry from '../components/Ministries/WomenMinistry';
import YouthMinistry from '../components/Ministries/YouthMinistry';

// Admin Components
import AnnouncementsManager from '../components/admin/AnnouncementsManager';
import CellGroups from '../components/admin/CellGroupsManager';
import DashboardHome from '../components/admin/DashboardHome';
import EventsManager from '../components/admin/EventsManager';
import AdminLayout from '../components/admin/layout/AdminLayout';
import Leaders from '../components/admin/LeadersManager';
import MessagesManager from '../components/admin/MessagesManager';
import MinistriesManager from '../components/admin/MinistriesManager';
import PaymentsManager from '../components/admin/PaymentsManager';
import Updates from '../components/admin/UploadsManager';

//______________________
// Auth Guard for Admin Routes
const AdminRoute = ({ children }) => {
  // Check if user is authenticated and is an admin
  const isAuthenticated = localStorage.getItem('token') !== null;
  const isAdmin = localStorage.getItem('admin') !== null;
  
  /*if (!isAuthenticated || !isAdmin) {
    // Redirect to login page if not authenticated or not an admin
    return <Navigate to="/admin/login" replace />;
  }*/
  
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/giving" element={<Giving />} />
      <Route path='/events' element={<Events/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/contact' element={<Contact/>}/>
      
      {/* Ministry Routes */}
      <Route path="/ministries" element={<MinistryPage />} />
      <Route path="/Women-ministry" element={<WomenMinistry />} />
      <Route path="/Youth-ministry" element={<YouthMinistry />} />
      <Route path="/Kids-ministry" element={<ChildrenMinistry />} />
      <Route path="/Teens-ministry" element={<TeensMinistry />} />
      
      <Route path='/cell-groups' element={<CellMinistry/>}/>
      <Route path='/cell-locator' element={<CellLocator/>}/>
      <Route path='/announcements' element={<Annoncements/>}/>
      <Route path='/welcome' element={<WelcomePage/>}/>
      <Route path='/soul-winning' element={<SoulWinning/>}/>
      <Route path='/campus' element={<Campus/>}/>

      {/* Giving Success and Failure Routes */}
      <Route path="/giving/success" element={<GivingSuccess />} />
      <Route path="/giving/failure" element={<GivingFailure />} />
      {/* Admin Routes */}
       {/*<Route path="/admin/login" element={<AdminLogin />} /> */}
      
      <Route path="/admin" element={
        <AdminRoute>
          <AdminLayout />
        </AdminRoute>
      }>
        <Route index element={<DashboardHome />} />
        <Route path="announcements" element={<AnnouncementsManager />} />
        <Route path="events" element={<EventsManager />} />
        <Route path="ministries" element={<MinistriesManager />} />
        <Route path="payments" element={<PaymentsManager />} />
        <Route path="messages" element={<MessagesManager />} />
        <Route path="cell-groups" element={<CellGroups />} />
        <Route path="updates" element={<Updates />} />
        <Route path="leaders" element={<Leaders />} />
      </Route>

      
      {/* 404 Route */}
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
};

export default AppRoutes; 